<template>
  <div class="your-view">
    <h1 class="text-[#ff9b05]">Flow</h1>
    <FlowChartComponent />
  </div>
</template>

<script>
import FlowChartComponent from '@/components/modals/plantasForm.vue';
// import FlowChartComponent from '../components/negocio/armazem.vue';

// import FlowChartComponent from '../components/Workflow.vue';

export default {
  name: 'YourView',
  components: {
    FlowChartComponent,
  },
};
</script>

<style scoped>
.your-view {
  padding: 20px;
  background-color: rgba(93, 93, 152, 0.55); /* Alterando para um fundo translúcido com cor similar */
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Adicionando uma sombra sutil */
}
</style>

